/* eslint-disable no-restricted-globals */
import React from 'react';
import { useHistory } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import { del } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';

function Profiles(props) {
  const history = useHistory();
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [signal, setSignal] = React.useState(0);

  const editProfile = (ent) => {
    history.push(`/profiles/edit/${ent.id}`);
  };

  const deleteProfile = async (obj) => {
    // eslint-disable-next-line no-alert
    if (confirm(props.t('Are you sure you want to delete this Profile?'))) {
      try {
        await del(`/api/profiles/${obj.id}`);
        setSignal(signal + 1);
      } catch (error) {
        toastr.error(error.message, 'Error');
      }
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="10">
            <Card>
              <CardBody>
                <CardTitle className="h4">{props.t('Profiles')}</CardTitle>

                <Can i="see" this="profiles">
                  <BaseGrid
                    url={url.GET_PROFILES}
                    hasSearch
                    create="/profiles/create"
                    shouldUpdate={signal}
                    className="table table-sm table-hover table-striped table-bordered fs-6"
                    config={
                    {
                      columns: {
                        id: { label: 'ID', sort: true },
                        name: { label: 'Profile Name', sort: true },
                        sku: { label: 'Sku', sort: true },
                        title: { label: 'Title', sort: true },
                        tags: {
                          label: 'Tags',
                          format: (x) => (x.map((r) => (r.label))),
                          badges: {
                            class: 'bg-info bg-soft text-dark p-2',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'bx bx-pencil',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Edit'),
                              click: editProfile,
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-close-thick',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteProfile,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Profiles"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Profiles.defaultProps = {
  t: (x) => (x),
};

Profiles.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Profiles));
